import { createReducer } from "typesafe-actions";

import SortOrder from "@mapmycustomers/shared/enum/SortOrder";
import FileTag from "@mapmycustomers/shared/types/entity/FileTag";
import User from "@mapmycustomers/shared/types/User";

import SortField from "../util/SortField";

import { Actions, fetchFileTags } from "./actions";

export interface ViewState {
  page: number;
  sortFieldName: SortField;
  sortOrder: SortOrder;
  userIds: User["id"][];
}

export interface FileTagsState {
  fileTags: FileTag[];
  loading: boolean;
  total: number;
  viewState: ViewState;
}

const initialState: FileTagsState = {
  fileTags: [],
  loading: false,
  total: 0,
  viewState: {
    page: 1,
    sortFieldName: SortField.NAME,
    sortOrder: SortOrder.ASC,
    userIds: [],
  },
};

const fileTags = createReducer<FileTagsState, Actions>(initialState)
  .handleAction(fetchFileTags.request, (state, { payload }) => ({
    ...state,
    loading: true,
    viewState: {
      page: payload.page,
      sortFieldName: payload.sortFieldName,
      sortOrder: payload.sortOrder,
      userIds: payload.userIds,
    },
  }))
  .handleAction(fetchFileTags.success, (state, { payload }) => ({
    ...state,
    fileTags: payload.fileTags,
    loading: false,
    total: payload.total,
  }))
  .handleAction(fetchFileTags.failure, (state) => ({
    ...state,
    loading: false,
  }));

export * from "./selectors";
export type FileTagsActions = Actions;
export default fileTags;
